import { useContext } from "react";
import { ModalInsertContext } from "context/ModalInsertContext";
import DecodeToken from "pages/Login/DecodeToken";

export function useStatus(status_id){
const modalcontext = useContext(ModalInsertContext);
const daneZamowienia = modalcontext.daneZamowienia;
const setDaneZamowienia = modalcontext.setDaneZamowienia;

function setStatus(status_id) {
// zmienia status zamówienia na do koretky przy każdej edycji gdy zamówienie jest przyjęte czyli ma stan 3
  if(daneZamowienia.stan ==3 ){
    setDaneZamowienia({...daneZamowienia, status:status_id, update:true })
  }
}
  return [setStatus];
}


// użycie

// const [add] = useHistoria()

// add(   {
//   kategoria: "Status zamówienia",
//   event: "Zmiana statusu zamówienia z "+ _status_dokumentu.filter(x=>x.id == daneZamowienia.status )[0].nazwa + " na "+ _status_dokumentu.filter(x=>x.id == event.target.value )[0].nazwa,
// })

// add(                    {
//   kategoria: "Stan zamówienia",
//   event: "Zmiana stanu zamówienia z "+ _stan_dokumentu.filter(x=>x.id == daneZamowienia.stan )[0].nazwa + " na "+ _stan_dokumentu.filter(x=>x.id == event.target.value )[0].nazwa}
// );

// add({kategoria: "Etap zamówienia",
//   event: "Zmiana etapu zamówienia z "+ _etapy_produkcji.filter(x=>x.id == daneZamowienia.etap )[0].nazwa + " na "+ _etapy_produkcji.filter(x=>x.id == event.target.value )[0].nazwa}
// );